export default __webpack_public_path__ + "static/media/dv_5.2d61ff6a.svg";